import type { FC } from "react";
import type { TimelineItemResponseDTO as TimelineItem } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { TimelineEntry } from "web_myplann/NotificationCenter/Components/TimelineEntry";
import { TimelineSection } from "web_myplann/NotificationCenter/Components/TimelineSection";
import { NOTIFICATION_CENTER_TABS } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import type { UpcomingGroup } from "web_myplann/NotificationCenter/Hooks/useGroupUpcomingItems";
import { TimelineDateStyle } from "web_myplann/NotificationCenter/Types/TimelineDateStyle";

interface TimelineGroupProps {
	group: UpcomingGroup;
	onItemClick: (item: TimelineItem) => void;
}

export const TimelineGroup: FC<TimelineGroupProps> = ({
	group,
	onItemClick,
}) => {
	const { t } = useResource();

	return (
		<TimelineSection
			title={t(group.labelResource)}
			muted={group.visualWeight === "muted"}
			testId={`timeline-group-${group.bucketKey}`}
		>
			{group.items.map((item, index) => (
				<TimelineEntry
					key={item.id}
					item={item}
					tab={NOTIFICATION_CENTER_TABS.Upcoming}
					onClick={onItemClick}
					isLast={index === group.items.length - 1}
					dateStyle={TimelineDateStyle.Absolute}
				/>
			))}
		</TimelineSection>
	);
};
